import React, { Component } from "react";
import { connect } from "react-redux";

// State
import { passwordRequest, passwordUpdateClearState } from "../../store/actions/user";

class PasswordRequest extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: ""
		};
	}

	componentWillUnmount() {
		this.props.passwordUpdateClearState();
	}

	handleInputChange(event) {
		event.preventDefault();
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.passwordRequest(this.state.email);
	}

	render() {
		const { isLoading, success, errors } = this.props;

		return (
			<div className="body_container padded_top padded_bottom">
				<h1>Request Password</h1>

				{success ? (
					<div className="success">
						Your new password has been sent to your email address.
						<br />
						Please ensure you check your junk mail if it does not arrive shortly!
					</div>
				) : (
					<div>
						<div>
							You can request a new password for your account by submitting your email
							address.
						</div>

						<form name="frm">
							<div className="form-field">
								{errors.email && (
									<div className="error msg_animate">{errors.email}</div>
								)}
								<input
									type="email"
									id="email"
									value={this.state.email}
									maxLength="255"
									placeholder="Your email"
									onKeyPress={e => this.handleKeyPress(e)}
									onChange={e => this.handleInputChange(e)}
								/>
							</div>

							<div className="btn_container">
								{errors.general && (
									<div className="error msg_animate">{errors.general}</div>
								)}
								<button
									className="btn submit-btn"
									name="submit"
									value="submit"
									disabled={isLoading}
									onClick={e => this.handleSubmit(e)}
								>
									<span>Request New Password</span>
								</button>
							</div>
						</form>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		errors: state.user.passwordRequestErrors,
		success: state.user.passwordRequestSuccess,
		isLoading: state.user.isLoading
	};
};

export default connect(
	mapStateToProps,
	{ passwordRequest, passwordUpdateClearState }
)(PasswordRequest);



// WEBPACK FOOTER //
// ./src/components/customer/PasswordRequest.js